import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["label", "errorMessage", "required"];
import * as React from 'react';
import cx from 'classnames';
import { Input } from '../../../input';
import styles from './styles.css';
var FormFieldInputComponent = /*#__PURE__*/React.forwardRef(function FormField(props, ref) {
  var label = props.label,
    errorMessage = props.errorMessage,
    required = props.required,
    inputProps = _objectWithoutProperties(props, _excluded);
  var labelClasses = cx(styles['label'], _defineProperty({}, styles['required'], required));
  return /*#__PURE__*/React.createElement("div", {
    ref: ref
  }, label && /*#__PURE__*/React.createElement("label", {
    className: labelClasses
  }, label), /*#__PURE__*/React.createElement(Input, inputProps), errorMessage && /*#__PURE__*/React.createElement("div", {
    className: styles['error_message']
  }, errorMessage));
});
FormFieldInputComponent.defaultProps = {
  required: false
};

/**
 * DEPRECATED
 *
 * Используйте простой FromField
 */
export var FormFieldInput = /*#__PURE__*/React.memo(FormFieldInputComponent);